var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19984 16.16H3.23984L3.81584 15.392C4.19984 14.864 4.43984 14.192 4.58384 13.376C2.18384 12.272 0.839844 10.208 0.839844 7.52005C0.839844 3.39205 3.95984 0.800049 8.99984 0.800049C14.0398 0.800049 17.1598 3.39205 17.1598 7.52005C17.1598 11.744 14.0878 14.24 8.99984 14.24H8.66384C7.89584 15.152 6.55184 16.16 4.19984 16.16ZM8.99984 1.76005C4.48784 1.76005 1.79984 3.92005 1.79984 7.52005C1.79984 10.592 3.67184 12.032 5.25584 12.656L5.59184 12.8L5.54384 13.184C5.44784 13.952 5.30384 14.624 5.01584 15.2C6.59984 15.008 7.51184 14.192 8.03984 13.52L8.18384 13.328H8.99984C15.4798 13.328 16.1998 9.29605 16.1998 7.56805C16.1998 3.92005 13.5118 1.76005 8.99984 1.76005Z",
    fill: "#1F2F3D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaCommentIcon);
export default __webpack_public_path__ + "static/media/insta-comment-icon.6acc0e16baeaaf2355e4cbece506bc95.svg";
export { ForwardRef as ReactComponent };